__turbopack_context__.v({
  "meteor": "styles-module__WoyNwa__meteor",
});
